import { Component, Input } from '@angular/core';

@Component({
  selector: 'inline-notification',
  templateUrl: './inline-notification.component.html',
  styleUrls: ['./inline-notification.component.scss'],
  standalone: false
})

/** The inline notification component may be used to display a full-width alert on any page, with visual options for priority level.
   * The notification is not time limited and does not contain an option to close it, so most use cases will require the *ngIf directive.
   */

export class InlineNotificationComponent {
  /** title displays the notification header
   * body includes the main content of the notification
   * priority sets the appearance of the notification and is restricted to three options:
   * info (the default) is blue, warning is yellow and error is red
   */
  @Input() title: string;
  @Input() body: string;
  @Input() priority: 'info' | 'warning' | 'error' = 'info';
}
